import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { combineLatest, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { showAnimation } from 'src/animations';
import { compare } from 'src/app/globals';
import { Availability } from '../../../classes';
import { AVAILABILITIES_PROVIDER_SERVICE, IAvailabilityProviderService } from '../../../interfaces';
import { LocationService } from '../../../services/location.service';

@Component({
  selector: 'app-location-availability-table',
  templateUrl: './location-availability-table.component.html',
  styleUrls: ['./location-availability-table.component.css'],
  animations: [ showAnimation ]
})
export class LocationAvailabilityTableComponent implements OnDestroy, OnInit {

  @Input() editMode: boolean = true;

  columns: { statusId: number, display: string, index: number }[] = [];
  rows: { display: string, componentId: number, values: { [key: number]: boolean } }[] = [];

  formArray: FormArray;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(AVAILABILITIES_PROVIDER_SERVICE) private _providerService: IAvailabilityProviderService,
    private _locationService: LocationService,
    private _controlContainer: ControlContainer,
    private _formBuilder: FormBuilder,
    private _changeDetectorRef: ChangeDetectorRef
  ) { }

  cellClicked(componentId: number, colIndex: number) {
    if(!this.editMode) return;
    let status = this.columns[colIndex].statusId;
    this._providerService.availabilities$.pipe(take(1)).subscribe((availabilities: Availability[]) => {
      let existingAvailability = availabilities.find(x => x.availabilitycomponent === componentId);
      let index = this.formArray.controls.findIndex(x => (x.value as Availability).availabilitycomponent === componentId);
      if (index === -1) {
        var availability = new Availability();
        availability.availabilityid = existingAvailability? existingAvailability.availabilityid: null;
        availability.availabilitycomponent = componentId;
        availability.availabilitystate = (existingAvailability && existingAvailability.availabilitystate === status? null: status);
        this.formArray.push(this._formBuilder.group(availability));
      } else {
        existingAvailability = this.formArray.controls[index].value;
        (this.formArray.controls[index] as FormGroup).controls['availabilitystate'].setValue(existingAvailability && existingAvailability.availabilitystate === status? null: status);
      }
      this.validate();
    });
  }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formArray = this._controlContainer.control as FormArray;
    this.validate();
  }

  validate() {
    combineLatest([this._locationService.loadAvailabilityComponents(), this._locationService.loadAvailabilityStatus(), this._providerService.availabilities$]).pipe(take(1))
      .subscribe(([components, status, availabilities]) => {
        let columns = [], rows = [];
        status.forEach((element, index) => {
          columns.push({ statusId: element.availabilitystateid, display: element.availabilitystatedesc, index: index, color: element.availabilitystatename });
        });
        components.forEach((element) => {
          let values = { };
          let currentAvailability = (this.formArray.value as Availability[]).find(x => x.availabilitycomponent === element.availabilitycomponentid);
          if (!currentAvailability) currentAvailability = availabilities.find(x => x.availabilitycomponent === element.availabilitycomponentid);
          columns.sort((a, b) => compare(a.index, b.index, true)).forEach(y => {
            values[y.index] = currentAvailability && currentAvailability.availabilitystate === y.statusId ? true : false;
          });
          rows.push({
            display: element.availabilitycomponentname,
            componentId: element.availabilitycomponentid,
            values: values
          });
        });
        if(this.columns.length !== columns.length) this.columns = columns;
        if(this.rows.length !== rows.length) this.rows = rows;
        else rows.forEach((row, index) => {
          Object.keys(row.values).forEach((key) => this.rows[index].values[key] = row.values[key]);
        });
      });
  }

}
